import { render, staticRenderFns } from "./TipoAlicuotaCombobox.vue?vue&type=template&id=6492ab1a&scoped=true&"
import script from "./TipoAlicuotaCombobox.vue?vue&type=script&lang=js&"
export * from "./TipoAlicuotaCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6492ab1a",
  null
  
)

export default component.exports